import { Typography } from "@mui/material";
import TaskUsage from "./TaskUsage";

const Unsubscribed = () => {
  return (
    <>
      <div className="account-page_subscription-type-container">
        <Typography className="account-page_subscription-label">
          Subscription status:
        </Typography>
        <Typography className="account-page_subscription-type account-page_subscription-type--free">
          Free
        </Typography>
      </div>

      <TaskUsage />
    </>
  );
};

export default Unsubscribed;
